import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { errMsg } from "./LoadError";

export function StageReviewBanner({ store, id, review, onCleared }) {
  if (!review?.flag) return null;
  const clear = async () => {
    try { await api.post(`/crm/stage-review/${store}/${id}/clear`); toast.success("Marked as reviewed"); onCleared && onCleared(); }
    catch (e) { toast.error(errMsg(e, "Could not update")); }
  };
  return (
    <div className="bg-amber-500/10 border border-amber-400/30 rounded-xl p-3.5 flex items-center justify-between gap-3 flex-wrap mb-4" data-testid="stage-review-banner">
      <div className="flex items-start gap-2 text-amber-200 text-sm"><AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" /><span><b>Needs manual stage review:</b> {review.reason}. Set the correct stage, then mark reviewed.</span></div>
      <button onClick={clear} data-testid="stage-review-clear" className="text-xs bg-amber-400 text-emerald-950 font-semibold rounded-lg px-3 py-1.5">Mark reviewed</button>
    </div>
  );
}
